import { Input } from "@/components/ui/input";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PdfUpload } from "./fund-research/PdfUpload";
import { ResearchButton } from "./fund-research/ResearchButton";
import { useFundResearch } from "./fund-research/useFundResearch";

export const FundResearch = () => {
  const {
    fundName,
    setFundName,
    isLoading,
    pdfFile,
    setPdfFile,
    handleResearch
  } = useFundResearch();

  return (
    <div className="flex flex-col gap-4">
      <Tabs defaultValue="name" className="w-full">
        <TabsList>
          <TabsTrigger value="name">Search by Fund Name</TabsTrigger>
          <TabsTrigger value="pdf">Upload Fund PDF</TabsTrigger>
        </TabsList>
        
        <TabsContent value="name">
          <Input
            placeholder="Enter fund name to research..."
            value={fundName}
            onChange={(e) => {
              setFundName(e.target.value);
              setPdfFile(null); // Clear PDF when entering fund name
            }}
            className="w-full md:w-96"
          />
        </TabsContent>
        
        <TabsContent value="pdf">
          <PdfUpload 
            onFileSelect={(file) => {
              setPdfFile(file);
              setFundName(""); // Clear fund name when PDF is selected
            }}
            pdfFile={pdfFile}
          />
        </TabsContent>
      </Tabs>

      <ResearchButton 
        isLoading={isLoading}
        disabled={isLoading || (!fundName && !pdfFile)}
        onClick={handleResearch}
      />
    </div>
  );
};